/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrderResourceDistance } from './orderResourceDistance';


export interface OrderResource { 
    orderId: number;
    title: string;
    price: string;
    location: string;
    locationFull: string;
    state: string;
    distance: OrderResourceDistance;
    hasVideo: boolean;
    recruitmentDate: string;
    imageUrl: string;
}

